import(/* webpackMode: "eager", webpackExports: ["Section"] */ "/app/fo/src/components/layout/Section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CTABanner"] */ "/app/fo/src/components/sections/CTABanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhyChooseUs"] */ "/app/fo/src/components/sections/WhyChooseUs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/fo/src/components/ui/button.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
